/**
 * IC-75 — the connectivity check's honest outcome (design §22.9.4, glossary §6.15).
 *
 * The SIP guard (`apps/sip-guard`) carries a structurally identical copy, because its image depends
 * on nothing in the workspace; a contract test there asserts both unions list the same kinds, and
 * {@link SIP_CHECK_OUTCOME_KIND} is the list it compares against.
 *
 * `sip_reachable_unauthenticated` verifies reachability, not the password — the portal says so.
 */
export const SIP_CHECK_TLS = ["tls_ok", "tls_unverified", "not_tls"];
/** Every kind, in design §22.9.4's order. The `satisfies` clause fails typecheck if the union grows. */
export const SIP_CHECK_OUTCOME_KIND = [
    "dns_failed",
    "blocked_destination",
    "unreachable",
    "tls_failed",
    "not_verified",
    "sip_reachable_unauthenticated",
    "credentials_accepted",
    "credentials_rejected",
    "sip_error",
];
/** Compile-time proof that {@link SIP_CHECK_OUTCOME_KIND} lists every kind. */
const EVERY_KIND_LISTED = true;
void EVERY_KIND_LISTED;
/** The two outcomes that move `unverified` → `verified` (§22.5.2, the copy table of §22.9.4). */
export function sipCheckVerifies(kind) {
    return kind === "credentials_accepted" || kind === "sip_reachable_unauthenticated";
}
//# sourceMappingURL=check.js.map